class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		// Section rendue dans un groupe : son id DOM n'est plus fixe, on cible la
		// classe posée par le schéma de sections/header.liquid.
		this.header = document.querySelector('.section-header');
		if (!this.header) return;
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.preventHide = false;
		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, {passive: true});

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
			observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (
			scrollTop > this.currentScrollTop &&
			scrollTop > this.headerBounds.bottom
		) {
			requestAnimationFrame(this.hide.bind(this));
		} else if (
			scrollTop < this.currentScrollTop &&
			scrollTop > this.headerBounds.bottom
		) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		this.header.classList.add(
			'shopify-section-header-hidden',
			'shopify-section-header-sticky',
		);
	}

	reveal() {
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		this.header.classList.remove(
			'shopify-section-header-hidden',
			'shopify-section-header-sticky',
			'animate',
		);
	}
}

// Le script est chargé par la section header : l'éditeur de thème le ré-exécute
// à chaque re-rendu de la section, une seconde définition lèverait une erreur.
if (!customElements.get('sticky-header')) {
	customElements.define('sticky-header', StickyHeader);
}
